import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToNext = () => {
    document.getElementById('app')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          transform: `translateY(${scrollY * 0.35}px) scale(1.05)`,
        }}
      >
        <img
          alt="El Último Redentor"
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black"></div>
        <div className="absolute inset-0 hero-vignette"></div>
      </div>

      <div className="absolute inset-0 z-10 opacity-40">
        <div className="particles-bg">
          {[...Array(28)].map((_, i) => (
            <div
              key={i}
              className="ember animate-flicker"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
              }}
            ></div>
          ))}
        </div>
      </div>

      <div className="relative z-20 max-w-6xl mx-auto px-6 text-center pt-16 md:pt-20">
        <h1 className="hero-title text-5xl md:text-7xl font-bold mb-2 glow-orange tracking-wide">
          EL ÚLTIMO REDENTOR
        </h1>

        <p className="text-xl md:text-2xl text-orange-500 mb-5 font-semibold tracking-[0.28em] md:tracking-[0.34em] hero-extended-right">
          EXTENDIDO
        </p>

        <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
          El infierno ya no está solo en las páginas.
          <br />
          <span className="hero-accent font-semibold">Ahora camina contigo.</span>
        </p>

        <div className="hero-panel max-w-3xl mx-auto mb-8">
          <p className="text-base md:text-lg text-gray-300 leading-relaxed">
            Cada símbolo escondido en la trilogía es una puerta.
            <br className="hidden md:block" />
            Escanéalo y descubre lo que permanece oculto entre el cielo, el infierno y la redención.
          </p>
        </div>

       
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center -mt-6">
          <button
            onClick={() => document.getElementById('descarga')?.scrollIntoView({ behavior: 'smooth' })}
            className="btn-inferno"
          >
            Descifrar los Sellos
          </button>
          <a
            href="https://portal.grmeneghetti.com.ar/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost"
          >
            Acceder al Portal
          </a>
        </div>
      </div>

      
    </section>
  );
};

export default HeroSection;
